import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Export")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Open ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Closed ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchBar = _resolveComponent("SearchBar")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return _withDirectives((_openBlock(), _createBlock(_component_el_container, { direction: "horizontal" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_aside, { width: "300px" }, {
        default: _withCtx(() => [
          _createVNode(_component_SearchBar, {
            useSearch: true,
            useStatusReports: true,
            useIntegration: true,
            useTags: true,
            tagType: 'report',
            onSearchChange: _ctx.atSearchChange,
            onStatusChange: _ctx.atStatusChange,
            onIntegrationChange: _ctx.atIntegrationChange,
            onTagQueryChange: _ctx.atTagQueryChange,
            onTagMatchChange: _ctx.atTagMatchChange
          }, null, 8, ["onSearchChange", "onStatusChange", "onIntegrationChange", "onTagQueryChange", "onTagMatchChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, { direction: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table, {
            data: _ctx.reports,
            stripe: "",
            "default-expand-all": true,
            onSortChange: _ctx.onSortChanged
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "title",
                label: "Title",
                sortable: "custom"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_link, {
                    href: `/#/reports/${row._id}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["href"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "integration",
                label: "Integration"
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(_ctx.getIntegrationName(row.integration)), 1)
                ]),
                _: 1
              }),
              (_ctx.isVAR || _ctx.isSuperAdmin)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    prop: "org",
                    label: "Organization"
                  }, {
                    default: _withCtx(({row}) => [
                      _createTextVNode(_toDisplayString(_ctx.orgMap[row.org]), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table_column, {
                prop: "date_created",
                label: "Created",
                sortable: "custom"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_ctx.convertDateString(scope.row.date_created, _ctx.userPrefs?.timezone)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "Options" }, {
                default: _withCtx(({row}) => [
                  (row.exporter)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        size: "mini",
                        icon: "el-icon-download",
                        onClick: () => _ctx.downloadReport(row._id)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "Status" }, {
                default: _withCtx(({row}) => [
                  (row.report_active === true)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: "success"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        type: "danger"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "onSortChange"]),
          _createVNode(_component_el_pagination, {
            class: "margin-auto margin-vert",
            background: "",
            layout: "sizes, prev, pager, next",
            "page-sizes": [10, 20, 50, 100, 200],
            total: _ctx.total,
            "page-size": _ctx.pageSize,
            "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pageSize = $event)),
            "current-page": _ctx.page,
            "onUpdate:current-page": _cache[2] || (_cache[2] = ($event: any) => (_ctx.page = $event))
          }, null, 8, ["total", "page-size", "current-page"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512)), [
    [_directive_loading, _ctx.fetchState === _ctx.FetchStates.FETCHING]
  ])
}